import toast from "react-hot-toast";
import { QOOHOO_WEBSITE_DOMAIN } from "constants/env";
import httpf from "utils/api/frontend/httpf";

export default async function setupNewUser(fullname) {
  try {
    const res = await httpf.post(
      `${QOOHOO_WEBSITE_DOMAIN}/api/auth/mobile/profile-update`,
      { fullname },
      {withCredentials: true}
    );

    return res;
  } catch (err) {
    console.log(err);
    // TODO: Silently fail for now as showing error isn't meaningful since creating order is still proceeded with
    // toast.error(err?.message);
  }
}
